export default __webpack_public_path__ + "static/media/applications-image-18.07c0b9b5.jpg";